import styled from 'styled-components';
import { marginProps, paddingProps, responsiveProperty, widthProps, heightProps, shouldForwardProp, } from 'modules/v2/utils/responsiveProperty';
export const StyledBox = styled.div.withConfig({
    shouldForwardProp,
}) `
  ${(props) => (props.display ? responsiveProperty('display', props.display) : 'display: flex')};

  ${(props) => props.flexDirection && responsiveProperty('flexDirection', props.flexDirection)};
  ${(props) => props.alignItems && responsiveProperty('alignItems', props.alignItems)};
  ${(props) => props.justifyContent && responsiveProperty('justifyContent', props.justifyContent)};
  ${(props) => props.gap && responsiveProperty('gap', props.gap)};
  ${(props) => props.borderRadius && responsiveProperty('borderRadius', props.borderRadius)};
  ${(props) => props.bg && responsiveProperty('background', props.bg)};
  ${(props) => props.alignSelf && responsiveProperty('alignSelf', props.alignSelf)};

  ${marginProps}
  ${paddingProps}
  ${widthProps}
  ${heightProps}
`;
